/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_OtherInputs */

const cs_enum_other = /** @type {(inputs: Enum_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jiné`)
};

const en_enum_other = /** @type {(inputs: Enum_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Enum_OtherInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_other = /** @type {((inputs?: Enum_OtherInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_OtherInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_other(inputs)
	return cs_enum_other(inputs)
});